import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { ProductAnalysisGroup3 } from '../../entities/control-tables/product-analysis-group3-entity';import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class ProductAnalysisGroup3Request extends BaseRequest {

    productAnalysisGroup3 : ProductAnalysisGroup3

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productAnalysisGroup3 = new ProductAnalysisGroup3()
  }
}